import { useEffect } from "react";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid2";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import AirportShuttleIcon from "@mui/icons-material/AirportShuttle";
import { useTranslation } from "react-i18next";
import { useNavigate, useSearchParams } from "react-router-dom";
import AppTheme from "../theme/AppTheme";

const ADS_TAG_ID = "AW-16938239808";
const ADS_CONVERSION_LABEL = "cMoBCLWk0qwaEMCO5Iw_";

export default function OrderSuccessCard() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const orderId = searchParams.get("orderId");
  const orderEmail = searchParams.get("email") || "";

  useEffect(() => {
    const handleConversion = () => {
      // console.log("google1");
      if (window.location.pathname !== "/success") {
        return;
      }
      // console.log("google2");
      const win = window as Window & {
        gtag?: (...args: unknown[]) => void;
      };
      if (typeof win.gtag !== "function") {
        return;
      }
      // console.log("google3");
      // console.log(orderEmail);
      
      const user_email = new URL(window.location.href).searchParams.get("email");

      win.gtag("set", "user_data", { email: user_email });
      win.gtag("event", "conversion", {
        send_to: `${ADS_TAG_ID}/${ADS_CONVERSION_LABEL}`,
      });
      // console.log("google4");
    };

    window.addEventListener("load", handleConversion);

    if (document.readyState === "complete") {
      handleConversion();
    }

    return () => {
      window.removeEventListener("load", handleConversion);
    };
  }, []);

  return (
    <AppTheme>
      <Grid
        container
        alignItems="center"
        justifyContent="center"
        sx={{
          height: {
            xs: "100%",
            sm: "calc(100dvh - var(--template-frame-height, 0px))",
          },
          mt: {
            xs: 4,
            sm: 0,
          },
        }}
      >
        <Grid
          size={{
            sm: 12,
            md: 6,
            lg: 6,
          }}
          sx={{
            display: "flex",
            flexDirection: "column",
            maxWidth: "100%",
            width: "100%",
            backgroundColor: { xs: "divider", sm: "divider" },
            alignItems: "start",
            px: { xs: 2, sm: 10 },
            gap: { xs: 4, md: 8 },
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              flexGrow: 1,
              width: "100%",
              maxWidth: { sm: "100%", md: 600 },
              gap: { xs: 5, md: "none" },
              minHeight: { xs: "auto", sm: 220 },
              justifyContent: "flex-start",
              py: { xs: 4, sm: 7 },
            }}
          >
            <Stack spacing={2} useFlexGap>
              <Typography variant="h1">
                <AirportShuttleIcon sx={{ fontSize: 60 }} />
              </Typography>
              <Typography variant="h5">{t("thankOrderTitle")}</Typography>
              <Typography variant="body1" sx={{ color: "text.secondary" }}>
                {t("thankOrderBody1")}
                {orderId ? <strong>&nbsp;#{orderId}</strong> : null}
                {t("thankOrderBody2", { email: orderEmail })}
              </Typography>
              <Button
                variant="contained"
                sx={{ alignSelf: "center", width: { xs: "100%", sm: "auto" } }}
                onClick={() => navigate("/orderdoor")}
              >
                {t("viewMyOrders")}
              </Button>
            </Stack>
          </Box>
        </Grid>
      </Grid>
    </AppTheme>
  );
}
